var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMultiple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18h1.269c.434 0 .652 0 .813-.053.567-.186.949-.824.916-1.53-.01-.201-.078-.45-.216-.946-.114-.414-.171-.62-.25-.794-.271-.602-.755-1.023-1.316-1.142-.161-.035-.342-.035-.704-.035l-2.512.035m-.81-1.835a3 3 0 1 0 .528-5.597M13.5 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-6.682 6h5.364c.483 0 .724 0 .94.046.747.16 1.393.72 1.755 1.523.104.232.18.507.333 1.059.183.662.275.993.287 1.26.044.943-.465 1.794-1.221 2.042-.215.07-.505.07-1.084.07H5.808c-.58 0-.87 0-1.084-.07-.756-.248-1.265-1.1-1.221-2.042.012-.267.104-.598.287-1.26.153-.552.229-.827.333-1.059.362-.803 1.008-1.363 1.755-1.523.216-.046.457-.046.94-.046Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultiple);
export default __webpack_public_path__ + "static/media/user-multiple.f2063ef8eb3526729fe499130e68739f.svg";
export { ForwardRef as ReactComponent };